import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SideBarItem from "./SideBarItem";
import "./styles.css";
import Swal from "sweetalert2";

const Sidebar = (props) => {
  const { loginStatus, loginHandler, menu } = props;
  const location = useLocation();
  const [active, setActive] = useState(1);

  useEffect(() => {
    menu.forEach((element) => {
      if (location.pathname === element.path) {
        setActive(element.id);
      }
    });
  }, [location.pathname, menu]);

  const __navigate = (id) => {
    setActive(id);
  };

  const logoutHandler = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
      cancelButtonText: "Cancel"
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (loginStatus) {
          localStorage.clear();
          loginHandler(false);
        } else {
          loginHandler(true);
        }
      }
    });
  };

  return (
    <nav className="sidebar">
      <div className="sidebar-container">
        {/* Logo / Brand Name */}
        <div className="sidebar-logo-container">
          <h1 className="sidebar-brand-name">RAMUSEN</h1>
          <div className="sidebar-brand-underline"></div>
        </div>

        <div className="sidebar-content">
          <div className="sidebar-items">
            {menu.map((item, index) => (
              <div key={index} onClick={() => __navigate(item.id)}>
                <SideBarItem active={item.id === active} item={item} />
              </div>
            ))}
          </div>

          <div className="sidebar-footer" onClick={logoutHandler}>
            <div className="sidebar-footer-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </div>
            <span className="sidebar-item-label">Logout</span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;